import { createSlice } from "@reduxjs/toolkit";

export const locationListSlice = createSlice({
  name: "locationListSlice",
  initialState: {
    locationList: [],
  },
  reducers: {
    setLocationList: (currentSlice, action) => {
      currentSlice.locationList = action.payload;
    },
  },
});

export const { setLocationList } = locationListSlice.actions;
export const locationListReducer = locationListSlice.reducer;
